import { useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import cls from './SucсessPage.module.scss';
import sberLogo from '@/shared/assets/icons/sberLogoBig.svg';
import { useAcquiringStore } from '../../model/store/useAcquiringStore';
import { setCookie } from '@/shared/lib/utils/setCookie';

const FailPage = () => {
    const { setIsAcquiring } = useAcquiringStore();

    useEffect(() => {
        setIsAcquiring(true);
        return () => setIsAcquiring(false);
    }, []);

    useLayoutEffect(() => {
        setCookie('acquiringFail', 'true', 1);
    }, []);

    return (
        <div className={cls.wrapper}>
            <img className={cls.image} src={sberLogo} alt="" />
            <h3>Что-то пошло не так</h3>
            <p>Страховой полис по вашему договору страхования не оформлен</p>
            <Link to="https://sberbank-insurance.ru/" className={cls.btn}>
                Вернуться на главную
            </Link>
        </div>
    );
};

export default FailPage;
